// extracted by mini-css-extract-plugin
export default {"body":"Projects_body__eDgWb"};